import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppMaterialModule } from 'src/app/app-material/app-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SelectPremierCredentialsComponent } from './select-premier-credentials.component';



@NgModule({
  declarations: [SelectPremierCredentialsComponent],
  imports: [
    AppMaterialModule,
    ReactiveFormsModule,
    CommonModule,
    MatCheckboxModule,
    FormsModule
  ]
})
export class SelectPremierCredentialsModule { }
